
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class EmptyListPlaceholder extends Vue {
  @Prop({ type: String, default: "" }) readonly title!: string;
  @Prop({ type: String, default: "" }) readonly subtitle!: string;
  @Prop({ type: String, default: "" }) readonly customStyle!: string;
}
